import { render, staticRenderFns } from "./allegro-operations.vue?vue&type=template&id=2b9d5310&scoped=true&"
import script from "./allegro-operations.vue?vue&type=script&lang=js&"
export * from "./allegro-operations.vue?vue&type=script&lang=js&"
import style0 from "./allegro-operations.vue?vue&type=style&index=0&id=2b9d5310&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9d5310",
  null
  
)

export default component.exports